import React, {useEffect,useState} from "react";
import "./RecommendRegal.scss";
import SwiperId from "react-id-swiper";
import {useHistory} from "react-router-dom";
import {useBasket, useDispatchBasket} from "../../hooks";
import {BasketAddRemove} from "..";
import {getProductsCategory_api, getProductsMall_api, getRecommendProduct_api} from "../../Services/apis";


const imageParamss = {
    slidesPerView: 'auto',
    spaceBetween: 50,
    rtl:true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    }
}


function numberWithCommas  (x) {
    if (x === 0) {
        return 0
    }
    if(x){
        return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;
    }

    return "-"

}

function limitText(txt,length) {
    if(txt.length>length){
        return txt.substr(0,length)+" ... "
    }else {
        return txt
    }
}

function RecommendRegal({item}) {
    //hooks
    const history = useHistory();

    const [data,setData] = useState([])
    const [color,setColor] = useState("#ffffff")

    useEffect( ()=>{
        console.log("444 7777",item)
        getProductsMall()
    },[])

    const getProductsMall = async ()=>{
        if(item.parent){
            try{
                const res = await getRecommendProduct_api(item.merchant.uid,item.parent.uid)
                setData(res.data.results)
            }catch(e){
                console.log(e)
            }
        }
    }


    return(
        // <span>swiper ...</span>
        <div style={{margin: "20px 16px 0 16px"}}>
            {/*{item.title?<div className="section-title"><span>{item.title}</span></div>:null}*/}
            <div className="online-off-section" style={{
                backgroundColor: color,
                margin: 8,
                padding: 8,
            }}>
                {data && data.length>0? <SwiperId {...imageParamss}>
                    <div className="swiper-card-container product-cardi" style={{backgroundColor:color}}>
                        <div className="swiper-card-body">
                                <span>{item.title?item.title:"محصولات پیشنهادی"}</span>
                        </div>
                    </div>
                    {data.map(i=>{
                        return(
                            <div style={{width:100}}>
                                <div className="swiper-card-container" onClick={()=>{
                                    history.push(`/online-store-product/${item.merchant.uid}/${i.uid}`)
                                }}>
                                    <div className="swiper-card-body" >
                                        {/*<BasketAddRemove i={i}/>*/}
                                        <div onClick={()=>{
                                            // history.push(`/online-store-product/${merchantId}/${i.uid}`)
                                        }}>
                                            <img src={i.image} alt=""/>
                                        </div>
                                    </div>
                                    <div className="price-section">
                                        <div className="price">
                                            {numberWithCommas(i.price)} ریال
                                        </div>
                                        {i.price_original-i.price>0?<div className="price-without-off">
                                            {numberWithCommas(i.price_original)}
                                        </div>:null}
                                    </div>
                                    {/*{i && i.discount_percentage!==0?*/}
                                    {/*    <div className="off">*/}
                                    {/*        <span>{i.discount_percentage+" % "}</span>*/}
                                    {/*    </div>:null*/}
                                    {/*}*/}
                                    <div className="info-section">
                                        <div className="name">{limitText(i.name,25)}</div>
                                        {/*<div className="weight">1500 گرمی میهن</div>*/}
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </SwiperId>:null}
            </div>
        </div>

    )
}

export {RecommendRegal};
